const widgetUpload = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M3.75 7.5V12h8.5V7.5h1.5v6H2.25v-6zM8 2l3.54 3.677H8.842v5.164H7.2V5.677H4.46z"/></svg>',
};

export { widgetUpload as default };
